module.exports = __webpack_public_path__ + "pack-box.3efa170a25a4997707b9c83d0b2a0360.svg";